export const Works = () => {
  return (
    <>
      <section class="works"></section>
    </>
  );
};
